import http from '../plugins/axios'
import { allCount } from '../graphql/queries/managementStats'
import { userSessionStats } from '../graphql/queries/userSessionStats'
import { signUpStats } from '../graphql/queries/signUpStats'
import { orderStats } from '../graphql/queries/orderStats'
import { userCitySignUp } from '../graphql/queries/userCitySignUp'
import { surveyCount } from '../graphql/queries/surveyCount'
import { platformStats } from '../graphql/queries/platformStats'
import { latestAbandonedCartItemsQuery, cartItemsV2ByUserQuery, adminDeleteCartItemV2Mutation, adminDeleteCartItemsV2ByUserMutation } from '../graphql/queries/latestAbandonedCartItems'


export const getDataDashboard = async () => {
  try {
    const response = await http.post(`/graphql`, {
      query: allCount
    })
    return response.data
  } catch(error) {
    throw error
  }
}

export const getDataStatsUser = async (type) => {
  try {
    const response = await http.post(`/graphql`, {
      query: userSessionStats,
      variables: {
        'type': type
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDataStatsSignUp = async (role, type) => {
  try {
    const response = await http.post(`/graphql`, {
      query: signUpStats,
      variables: {
        'role': role,
        'type': type
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDataStatsTotalOrder = async (status, type) => {
  try {
    const response = await http.post(`/graphql`, {
      query: orderStats,
      variables: {
        'status': status,
        'type': type
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDataStatsUserCitySignup = async () => {
  try {
    const response = await http.post(`/graphql`, {
      query: userCitySignUp,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDataStatsUserSurvey = async () => {
  try {
    const response = await http.post(`/graphql`, {
      query: surveyCount,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getDataStatsPlatform = async () => {
  try {
    const response = await http.post(`/graphql`, {
      query: platformStats,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getLatestAbandonedCartItems = async () => {
  try {
    const response = await http.post(`/graphql`, {
      query: latestAbandonedCartItemsQuery,
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const getAbandonedCartItemsByUser = async (userId) => {
  try {
    const response = await http.post(`/graphql`, {
      query: cartItemsV2ByUserQuery,
      variables: {
        user_id: userId
      }
    })
    return response.data
  } catch (error) {
    throw error
  }
}

export const deleteAbandonedCartItem = async (id) => {
  try {
    const response = await http.post(`/graphql`, {
      query: adminDeleteCartItemV2Mutation,
      variables: {
        id: id
      }
    })
    if (response?.data?.data?.adminDeleteCartItemV2) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    throw error
  }
}

export const clearAbandonedCartItemsByUser = async (userId) => {
  try {
    const response = await http.post(`/graphql`, {
      query: adminDeleteCartItemsV2ByUserMutation,
      variables: {
        user_id: userId
      }
    })
    if (response?.data?.data?.adminDeleteCartItemsV2ByUser) {
      return { success: true }
    }
    return { success: false }
  } catch (error) {
    throw error
  }
}